// src/utils/adminRoutes.ts
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../lib/firebase';

/** localStorage: 最後に開いた企業アカウント（管理画面） */
export const LAST_ADMIN_COMPANY_ID_KEY = 'lastAdminCompanyId';

/** users/{uid}/companies が空のときの URL プレースホルダ（リダイレクト先専用） */
export const ADMIN_NO_COMPANY_PLACEHOLDER = '__no_company__';

// 請求アカウントは会社から独立したため /billing に移設済み（ここには含めない）
export const ADMIN_SECTIONS = [
  'dashboard',
  'workspaces',
  'settings',
  'members',
] as const;

export type AdminSection = (typeof ADMIN_SECTIONS)[number];

export function isAdminSection(s: string | undefined): s is AdminSection {
  return !!s && (ADMIN_SECTIONS as readonly string[]).includes(s);
}

export function adminOrgPath(companyId: string, section: AdminSection): string {
  const enc = encodeURIComponent(companyId);
  return `/admin/org/${enc}/${section}`;
}

export function readLastAdminCompanyId(): string | null {
  try {
    return window.localStorage?.getItem(LAST_ADMIN_COMPANY_ID_KEY) || null;
  } catch {
    return null;
  }
}

export function writeLastAdminCompanyId(id: string): void {
  try {
    window.localStorage?.setItem(LAST_ADMIN_COMPANY_ID_KEY, id);
  } catch {
    /* ignore */
  }
}

export async function fetchUserCompanyIds(uid: string): Promise<string[]> {
  const snap = await getDocs(collection(db, `users/${uid}/companies`));
  return snap.docs.map((d) => d.id);
}

export function pickCompanyIdFromUserList(ids: string[], last: string | null): string | null {
  if (ids.length === 0) return null;
  if (last && ids.includes(last)) return last;
  return ids[0] ?? null;
}
